import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="not-found-page">
      <SEO
        title="404 - Page Not Found"
        description="The page you are looking for does not exist. Please go back to the homepage of Gateway Financial Services Limited."
      />
      <section className="inn-banner-slider">
        <div className="carousel slide">
          <div className="carousel-inner">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/online-trading-bg.jpg')",
              }}
            >
              <div className="carousel-caption">
                <h1>404</h1>
                <h2>Page Not Found</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="welcome-section"
        style={{ padding: "100px 0", textAlign: "center" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h3>Oops! The page you're looking for isn't here.</h3>
              <p className="spc-txt">It might have been moved or deleted.</p>
              <Link to="/" className="lm-btn">
                Go Back Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
